var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89118 7.30684L1.98998 8.29576L1 6.39453",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5852 3.3572L15.9237 2.05606L17.2051 0.56708",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1446 14.832L20.5245 16.2888L19.0688 17.669",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49567 6.46089C2.99508 5.50144 3.70173 4.66515 4.56439 4.01265C5.42706 3.36015 6.42411 2.9078 7.48325 2.6884C11.4504 1.82295 15.4089 4.1602 16.3248 7.90891C17.2407 11.6576 14.767 15.398 10.7997 16.2627",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2752 1.94703C17.7414 1.91902 18.2082 1.99302 18.6429 2.16387C19.0777 2.33472 19.4699 2.5983 19.7923 2.93626C20.1148 3.27422 20.3597 3.67843 20.5099 4.12071C20.6601 4.56299 20.7121 5.03272 20.6623 5.49715C20.6124 5.96159 20.4618 6.40956 20.2211 6.80986C19.9804 7.21016 19.6553 7.55316 19.2685 7.81495C18.8816 8.07674 18.4423 8.25104 17.9812 8.32568C17.5202 8.40033 17.0483 8.37354 16.5986 8.24717",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06356 16.251H1.75598",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0125 16.251H5.70496",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9641 16.251H10.0961",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgile);
export default __webpack_public_path__ + "static/media/agile.22d39ad0a29c9294e961742d2fd5ee8e.svg";
export { ForwardRef as ReactComponent };